import {ApiService} from './api.service';
import {Injectable} from '@angular/core';
import {ServService} from './serv.service';
import {ServModel} from '../models/serv.model';
import {OrderModel} from '../models/order.model';
import {OrderService} from './order.service';

@Injectable()
export class TasksService {

    list: any = [];
    current: any = {};
    loading = false;

    constructor(public apiService: ApiService, public servService: ServService, public orderService: OrderService) {

    }

    getAll(filter: any) {
        let data = '';
        Object.keys(filter).forEach(k => {
            data += 'filter-' + k + '=' + filter[k] + '&';
        });
        this.loading = true;
        this.list = [];
        this.apiService.get('tasks', data).subscribe(res => {
            this.loading = false;
            const today = new Date().getTime();
            res.data.forEach(e => {
                if (filter.type === 1) {
                    this.list.push(ServModel.j2o(e, this.servService));
                }
                if (filter.type === 2) {
                    let or = OrderModel.j2o(e, this.orderService);
                    or.deliveryWish.setHours(23, 59, 59);
                    or.late = or.deliveryWish.getTime() < today;
                    this.list.push(or);
                }
            });
        }, (_err) => {
            this.apiService.error(_err);
        });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/services/tasks.service.ts